<script>
  export let data = { properties: [] },
    contact;

  const properties = data.properties || [];
</script>

<ul>
  {#each properties as iter}
    {#if iter}
      <li><b>{iter.property.label}</b>: {iter.value}</li>
    {/if}
  {/each}
</ul>
